<div class="modal-header">
  <h4 class="modal-title">Launch History - {{campaignName()}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
</div>
<div class="modal-body">
  <div class="custom-table">
    @if (loading()) {
    <div class="text-center py-4">
      <span>Loading...</span>
    </div>
    }
    @if (!loading() && launchHistory().length > 0) {
    <table width="100%" class="sb-table table dataTable no-footer">
      <thead>
      <tr>
        <th>Launch Code</th>
        <th>Scheduled For</th>
        <th>Launched At</th>
        <th>By</th>
        <th>Result</th>
        <th>Influencers<br>Participated</th>
        <th>Sent<br>Emails</th>
      </tr>
      </thead>
      <tbody>
      @for (entry of launchHistory(); track entry) {
      <tr>
        <td><small>{{entry.launch_code}}</small></td>
        <td>{{entry.scheduled_at ? smartDateFormat(entry.scheduled_at) : '-'}}</td>
        <td>{{entry.launched_at ? smartDateFormat(entry.launched_at) : '-'}}</td>
        <td>{{entry.launched_by ? (entry.launched_by.first_name + ' ' + entry.launched_by.last_name) : '-'}}</td>
        <td (mouseenter)="onBadgeHover($event)" (mouseleave)="showLegend = false">
          <span class="badge" [class]="getResultBadgeClass(entry.result)" style="cursor: help;">
            {{getResultLabel(entry.result)}}
          </span>
          @if (showLegend && statusLegend().length) {
          <div class="legend-popover" [style.top.px]="legendTop" [style.left.px]="legendLeft">
            <table style="font-size: 0.75rem; border-collapse: collapse; width: 100%; border: none;">
              <tbody>
              @for (pair of statusLegendPairs; track pair) {
              <tr>
                <td style="padding: 2px 4px; white-space: nowrap;"><span class="badge" [class]="getResultBadgeClass(pair[0].result)"style="min-width: 90px; text-align: center;">{{pair[0].label}}</span></td>
                <td style="padding: 2px 6px;">{{pair[0].description}}</td>
                @if (pair[1]) {
                <td style="padding: 2px 4px 2px 16px; white-space: nowrap;"><span class="badge" [class]="getResultBadgeClass(pair[1].result)"style="min-width: 90px; text-align: center;">{{pair[1].label}}</span></td>
                }
                @if (pair[1]) {
                <td style="padding: 2px 6px;">{{pair[1].description}}</td>
                }
                @if (!pair[1]) {
                <td colspan="2"></td>
                }
              </tr>
              }
              </tbody>
            </table>
          </div>
          }
        </td>
        <td>{{entry.influencer_count}}</td>
        <td>{{entry.email_count}}</td>
      </tr>
      }
      </tbody>
    </table>
    }
    @if (!loading() && launchHistory().length === 0) {
    <div class="text-center py-4 text-muted">
      No launch history available.
    </div>
    }
  </div>
  @if (!loading()) {
  <div class="launch-timeline mt-4">
    <h5 class="launch-timeline-gutter">Timeline</h5>
    @if (timelineUnavailable()) {
    <div class="launch-timeline-gutter text-muted py-2">The timeline could not be loaded.</div>
    }
    @if (!timelineUnavailable() && timelineEvents().length === 0) {
    <div class="launch-timeline-gutter text-muted py-2">No launch events recorded.</div>
    }
    @if (timelineEvents().length > 0) {
    <table width="100%" class="launch-timeline-table sb-table table dataTable no-footer">
      <thead>
      <tr>
        <th>Time</th>
        <th>Event</th>
        <th>By</th>
        <th>Details</th>
      </tr>
      </thead>
      <tbody>
      @for (event of timelineEvents(); track event) {
      <tr>
        <td class="text-nowrap" [title]="event.at">{{smartDateFormat(event.at)}}</td>
        <td><span class="badge" [class]="getEventBadgeClass(event.severity)">{{getEventLabel(event.type)}}</span></td>
        <td>{{getEventActor(event)}}</td>
        <td class="launch-timeline-message">{{event.message}}</td>
      </tr>
      }
      </tbody>
    </table>
    }
    @if (timelineNotes().length) {
    <small class="launch-timeline-gutter text-muted d-block mt-2">{{timelineNotes().join(' ')}}</small>
    }
  </div>
  }
</div>
<input type="hidden" ngbAutofocus>
